import PillarContributors from './PillarContributors'

export default PillarContributors